import React from 'react';
import { useParams } from 'react-router';

import { Typography } from '@mui/material';

import Footer from 'main/components/Footer';

import { bulletins } from './constants';
import useStyles from './styles';

const PER_PAGE = 100;

const Sitemap: React.FC = () => {
    const { classes } = useStyles();

    const { page } = useParams<{ page?: string }>();
    const pageNumber = parseInt(page || '1');

    const links = bulletins
        .map((collection) =>
            collection.bulletins.map((bulletin) => (
                <a key={bulletin} href={'/' + collection.type + '/' + bulletin}>
                    {bulletin}
                </a>
            ))
        )
        .flat();

    const paginationLinks = Array.from({ length: Math.ceil(links.length / PER_PAGE) }, (_, index) => (
        <a key={index} href={index ? `/sitemap/${index + 1}` : '/sitemap'}>
            {index + 1}
        </a>
    ));

    const linksOnPage = links.slice((pageNumber - 1) * PER_PAGE, pageNumber * PER_PAGE);

    return (
        <div className={classes.root}>
            <Typography variant="h1" component="h1" gutterBottom>
                Top vulnerabilities
            </Typography>

            <div className={classes.links}>{linksOnPage}</div>

            <Typography variant="h2" component="h2" className={classes.more} gutterBottom>
                More vulnerabilities
            </Typography>

            <div className={classes.paging}>{paginationLinks}</div>

            <Footer />
        </div>
    );
};

export default Sitemap;
